export default __webpack_public_path__ + "static/media/kalahastiTemple1.ed760a13.png";